module.exports = __webpack_public_path__ + "static/media/checked.39f4d315.png";